const route = {
	path: '/accounting-accounts',
	name: 'accounting-accounts-by-subsidiary',
	meta: {
		title: 'Cuentas Contables',
	},
	component: () => import('@/pages/accounting-accounts/page-accounting-accounts-by-subsidiary'),
	children: [
		{
			path: 'new',
			name: 'accounting-account-by-subsidiary-new',
			meta: {
				title: 'Crear Cuenta Contable',
			},
			component: () => import('@/pages/accounting-accounts/page-accounting-account-new'),
			props: true,
		},
		{
			path: ':accountId/edit',
			name: 'accounting-account-by-subsidiary-edit',
			meta: {
				title: 'Editar Cuenta Contable',
			},
			component: () => import('@/pages/accounting-accounts/page-accounting-account-new'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accounting-accounts-by-subsidiary.js